module.exports = __webpack_public_path__ + "static/media/bean-top-shine.63e00613.svg";